"use strict";

const maps = require('./charMaps');
const ignoreValue = new RegExp('^(_)+([a-zA-Z0-9]+)(_)+$');

/**
 *
 * @param {String} message
 * @param {String} strategy
 * @constructor
 * @name {PseudoL10nString}
 */
class PseudoL10nString {
  constructor(text) {
    this._pseudo = {};
    this._createPseudo(text);
  }
  static builder(message) {
    return new PseudoL10nString(message);
  }
  _createPseudo(str) {
    for (const key of Object.keys(this._strategies)) {
      this._pseudo[key] = this.pseudoLocalizeWith(this._strategies[key], str);
    }
  }
  getPseudo() {
    return (this._pseudo);
  }
  /**
   * Returns the expansion string
   *
   * @param {Int} len
   * @param {Object} strategy
   * @return {String}
   */
  _getExtension(len, ratio, extChar, locale) {
    let i, extstr = '', exp = len <= this._expMap.length ? this._expMap[len] : len * 0.16;
    exp = (ratio > 0) ? parseInt(exp / ratio) : 0;
    if (exp === 0 || extChar.length === 0)
      return extstr;
    extstr = extChar.repeat(exp);
    if (exp <= 3)
      return extstr;

    var array = [];
    for (i = 0; i < exp; i++) {
      if (i === 1 || (i > 0 && (i % 6) === 0))
        array.push(' ');
      else
        array.push(extChar);
    }
    extstr = array.join('');
    return extstr;
  }
  /**
   * Returns the transcoded string according to the mapping table
   *
   * @param {Map} charMap
   * @param {String} str
   * @return {String}
   */
  _transformString(strategy, str) {
    if (!str || str.length === 0 || ignoreValue.test(str)) {
      return str;
    }
    var charMap = strategy.map;

    //replace escaped characters: \\n \\t \\r \\uXXXX
    str = str.replace(/\\[nrt]|\\u([0-9A-Fa-f]{4})/g,"%$&!");
    const {result,charCount} = str.split('').reduce(({ignoreFn, result, charCount}, char, idx) => {
      // if we can stop ignoring
      if (ignoreFn && ignoreFn(char, idx)) {
        ignoreFn = null;
      }
      if (!ignoreFn) {
        // if we need to start ignoring
        ignoreFn = this._ignoreMap[char];
        if (!ignoreFn) {
            if (char.match(/[a-z0-9]/i))
               charCount+=1;
            if (charMap!=null && charMap[char]) {
               char = charMap[char];
            }
        }
      }
      result += char;
      return {ignoreFn, result, charCount}
    }, {ignoreFn: null, result: '', charCount: 0});
    // put escaped character back in the string
    var res2 = result.replace(/\%(\\[nrt]|\\u([0-9A-Fa-f]{4}))\!/g,function(match,offset,start) {
        return match.substr(1).slice(0, -1);
    });
    var res =strategy.prefix
            + res2
            + this._getExtension(charCount,strategy.ratio,strategy.extChar,strategy.locale)
            + strategy.suffix;
    return res;
  }
  /**
   * Returns the strategies options table
   *
   * @param {String} strategy
   * @return {Object}
   */
  _getStrategy(strategy) {
    var ps;
    switch (strategy) {
      case "plxx":
        ps = strategies['plxx'];
        break;
      case "frxx":
        ps = strategies['frxx'];
        break;
      case "zhxx":
        ps = strategies['zhxx'];
        break;
      default:
        ps = strategies['plxx'];
        break;
    }
    return ps;
  }
  /**
   * Convert a string from UTF-8 to ASCII with Unicode Escaped Notation
   *
   * @param {String} strategy
   * @return {String}
   */
  _utf8_2ascii(str) {
    var out = "";
    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) < 0x80) {
        out += str.charAt(i);
      } else {
        var u = "" + str.charCodeAt(i).toString(16).toUpperCase();
        out += "\\u" + (u.length === 2 ? "00" + u : u.length === 3 ? "0" + u : u);
      }
    }
    return out;
  }
  /**
   * Indicates if a message contains placeholder
   *
   * @param {String} strategy
   * @return {boolean}
   */
  _hasPlaceholder(str) {
    var regex = /\{[A-Za-z0-9_]+}/g;
    return str.match(regex);
  }
  /**
   * Pseudo-localize a string using a given strategy
   *
   * @param {String} strategy
   * @param {String} str
   * @return {String}
   */
  pseudoLocalizeWith(strategy, str) {
    var result = this._transformString(strategy, str);
    return (this._utf8_2ascii(result));
  }
  /**
   * Pseudo-localize a string using this strategy name
   *
   * @param {String} name
   * @param {String} str
   * @return {String}
   */
  pseudoLocalize(name, str) {
    if (str.length <= 1)
      return str;
    var strategy = this._getStrategy(name);
    return (this.pseudoLocalizeWith(strategy));
  }
}


/**
 * @type {Array} Mapping table for expansion characters
 * @ignore
 */

PseudoL10nString.prototype._expMap= [
                                   0, 0, 1, 2, 3, 3, 3, 3, 4, 4,
                                   4, 5, 5, 5, 6, 6, 7, 7, 8, 8,
                                   8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
                           /*30*/  8, 8, 9, 9, 9, 9, 9, 9, 9,10,
                                  10,10,10,10,11,11,11,11,12,12,
                                  12,12,12,12,12,12,12,12,12,12,
                                  12,12,12,12,12,12,12,12,12,12,
                                  12,12,12,12,12,12,13,13,13,13,
                           /*80*/ 13,13,13,13,14,14,14,14,14,14];
                                /* 0, 1, 2, 3, 4, 5, 6, 7, 8, 9*/

/**
 * @type {Map} Mapping table for characters to ignore
 * @ignore
 */

PseudoL10nString.prototype._ignoreMap = {
  // html
  '<': (char) => char === '>',
  // html
  '{': (char) => char === '}',
  // macro function
  '%': (char) => ~[' ', ',', ':', ';', '?', '!', ')', '}', ']'].indexOf(char),
  //macro variable, html entities
  '&': (char) => ~[' ', ';'].indexOf(char)
};

/**
 * @type {Map} Mapping table for strategies to pseudo-translate
 * @ignore
 */
PseudoL10nString.prototype._strategies = {
  pl_XX: {
    prefix: '[',
    suffix: ']',
    map: maps.pl_pseudoCharMap,
    extChar: '@',
    quote: '',
    locale: 'pl_XX',
    ratio: 1
  },
  zh_CN_pseudo: {
    prefix: 'Ｘ',
    suffix: 'Ｚ',
    map: null,
    extChar: '补',
    quote: '',
    locale: 'zh_CN_pseudo',
    ratio: 1.25
  },
   ar_XX: {
    prefix: '',
    suffix: '',
    map: maps.ar_pseudoCharMap,
    extChar: '',
    quote: '',
    locale: 'ar_XX',
    ratio: 1
  }
};

module.exports = PseudoL10nString.builder;
